module.exports = __webpack_public_path__ + "static/media/imageErick.ed9cc1f8.png";